module.exports = __webpack_public_path__ + "img/3.93c4ae09.png";